import * as LDClient from "launchdarkly-js-client-sdk";
import rollbar from "lib/rollbar";

type FlagValue = number | string | boolean | null;
type FeatureFlagClient = {
    variation: (flagName: string, defaultValue: FlagValue) => FlagValue;
};

let featureFlagClient: FeatureFlagClient;

export interface FeatureFlagsWindow extends Window {
    cypress_feature_flags?: { [key: string]: FlagValue };
    user: {
        launch_darkly_bootstrap_data: { [key: string]: FlagValue };
        launch_darkly_identifiers: object;
    };
    LAUNCH_DARKLY_CLIENT_SIDE_ID: string;
}

declare let window: FeatureFlagsWindow;

export function feature(name: string, defaultValue: FlagValue = null) {
    if (window.cypress_feature_flags && name in window.cypress_feature_flags) {
        // cypress overrides
        return window.cypress_feature_flags[name];
    }
    if (!featureFlagClient) {
        const data = window.user?.launch_darkly_bootstrap_data;

        if (data && name in data) {
            return data[name];
        }

        return defaultValue;
    }

    return featureFlagClient.variation(name, defaultValue);
}

export function initFFClient() {
    if (featureFlagClient) {
        rollbar.error("Attempted to double initialize feature flag client");
        return;
    }

    if (
        !window.LAUNCH_DARKLY_CLIENT_SIDE_ID ||
        !window.user ||
        !window.user.launch_darkly_identifiers ||
        !window.user.launch_darkly_bootstrap_data
    ) {
        return;
    }

    // https://docs.launchdarkly.com/sdk/features/bootstrapping#javascript
    const newClient = LDClient.initialize(
        window.LAUNCH_DARKLY_CLIENT_SIDE_ID,
        window.user.launch_darkly_identifiers,
        {
            bootstrap: window.user.launch_darkly_bootstrap_data,
        },
    );

    newClient
        .waitForInitialization()
        .then(() => {
            featureFlagClient = newClient;
        })
        .catch((e: string) => {
            rollbar.error(e);
        });
}
